import { useEffect, useState } from 'react';
import {
	AuthLayout,
	ButtonBlockPrimary,
	FormGroup,
	InputDate,
	InputPhoneNumber,
	InputTextArea,
	InputTextIcon,
	InputTextblock,
	RadioButton,
	SelectDropDown,
} from '../components';
import { getCity, getDistrict, getProvinsi } from '../service/locationService';
import { Toption, initialOption } from '../type/option';
import { Tprovinsi } from '../type/provinsi';
import { Tcity } from '../type/city';
import { Tdistrict } from '../type/district';
import { Tusers } from '../type/users';
import { initialMemberType } from '../type/memberType';
import { useDispatch, useSelector } from 'react-redux';
import { setRegisterForm } from '../redux/utlsSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { showMessage } from '../utls/message';
import { RootState } from '../redux/store';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { getByReffCode } from '../service/usersService';
import { FiRefreshCw } from 'react-icons/fi';
import { searchMitra } from '../service/authService';

const Register = () => {
	const { code } = useParams();
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const { registerForm } = useSelector(
		(state: RootState) => state.reducer.utlsSlice
	);

	const [salesReffCode, setSalesReffCode] = useState(
		registerForm.salesReffCode
	);
	const [identityNumber1, setIdentityNumber1] = useState(
		registerForm.identityNumber1
	);
	const [identityNumber2, setIdentityNumber2] = useState(
		registerForm.identityNumber2
	);
	const [fullName, setFullName] = useState(registerForm.fullName);
	const [gender, setGender] = useState(registerForm.gender);
	const [birthDate, setBirthDate] = useState<Date>(
		registerForm.birthDate !== ''
			? new Date(registerForm.birthDate)
			: new Date()
	);
	const [placeOfBirth, setPlaceOfBirth] = useState(registerForm.placeOfBirth);
	const [provinsiList, setProvinsiList] = useState<Toption[]>([]);
	const [selectProvinsi, setSelectProvinsi] = useState<Toption>(
		registerForm.provinsi == null
			? initialOption
			: {
					label: registerForm.provinsi.provinsiName,
					value: registerForm.provinsi.id?.toString() || '0',
					data: registerForm.provinsi,
			  }
	);
	const [cityList, setCityList] = useState<Toption[]>([]);
	const [selectCity, setSelectCity] = useState<Toption>(
		registerForm.city == null
			? initialOption
			: {
					label: registerForm.city.cityName,
					value: registerForm.city.id?.toString() || '0',
					data: registerForm.city,
			  }
	);
	const [districtList, setDistrictList] = useState<Toption[]>([]);
	const [selectDistrict, setSelectDistrict] = useState<Toption>(
		registerForm.city == null
			? initialOption
			: {
					label: registerForm.district.districtName,
					value: registerForm.district.id?.toString() || '0',
					data: registerForm.district,
			  }
	);
	const [address1, setAddress1] = useState(registerForm.address1);
	const [email, setEmail] = useState(registerForm.email);
	const [password, setPassword] = useState(registerForm.password);
	const [phone, setPhone] = useState(registerForm.phone || '');

	const [selectedParent, setSelectedParent] = useState<Tusers | undefined>();

	const dispatch = useDispatch<any>();

	const navigate = useNavigate();

	const onSubmit = async () => {
		if (salesReffCode.length === 0) {
			return showMessage('No Reff Code Wajib Diisi', 'error');
		}

		if (identityNumber1.length < 10) {
			return showMessage('No KTP Wajib Diisi', 'error');
		}

		if (identityNumber2.length < 10) {
			return showMessage('No KK Wajib Diisi', 'error');
		}

		if (fullName.length < 6) {
			return showMessage('No Nama Lengkap Wajib Diisi', 'error');
		}

		if (email.length < 6) {
			return showMessage('No Email Wajib Diisi', 'error');
		}

		if (!isValidPhoneNumber(phone)) {
			return showMessage('Format No Hp tidak sesuai ', 'error');
		}

		if (selectDistrict.data == null) {
			return showMessage('Alamat Belum Di isi dengan Benar', 'error');
		}

		const data: Tusers = {
			code: '',
			identityNumber1: identityNumber1,
			identityNumber2: identityNumber2,
			nickName: '',
			fullName: fullName,
			gender: gender,
			birthDate: birthDate.toUTCString(),
			placeOfBirth: placeOfBirth,
			memberType: initialMemberType,
			email: email,
			userName: '',
			phone: phone,
			provinsi: selectProvinsi.data,
			city: selectCity.data,
			district: selectDistrict.data,
			address1: address1,
			address2: '',
			password: password,
			joinDate: new Date().toUTCString(),
			reffCode: '',
			block: false,
			salesReffCode: salesReffCode,
			register: true,
			cssClass: '',
		};

		dispatch(setRegisterForm(data));

		navigate('/register/term-of-condition');
	};

	const handleGenderChange = (value: string) => {
		setGender(value);
	};

	const getDataProvinsi = async (keyword: string) => {
		const data = {
			keyword: keyword,
		};
		const response = await getProvinsi(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tprovinsi) => {
				items.push({
					label: item.provinsiName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setProvinsiList(items);
		}
	};

	const getDataCity = async (keyword: string, provinsiId: string) => {
		const data = {
			keyword: keyword,
			provinsiId: provinsiId,
		};
		const response = await getCity(data);
		if (!response?.error) {
			const items: Toption[] = [];

			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tcity) => {
				items.push({
					label: item.cityName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setCityList(items);
		}
	};

	const getDataDistrict = async (keyword: string, cityId: string) => {
		const data = {
			keyword: keyword,
			cityId: cityId,
		};
		const response = await getDistrict(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tdistrict) => {
				items.push({
					label: item.districtName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setDistrictList(items);
		}
	};

	const getDataByReffCode = async (code: string) => {
		const response = await getByReffCode(code);
		if (!response?.error) {
			const parent: Tusers = response.data;
			setSalesReffCode(parent.code);
			getDataMitra(parent.code);
		}
	};

	const getDataMitra = async (code: string | undefined) => {
		const params = {
			keyword: code || salesReffCode,
		};

		const response = await searchMitra(params);
		if (response.code === 200 && !response.error) {
			const users = response.data;
			setSelectedParent(users);
		} else {
			setSelectedParent(undefined);
		}
	};

	useEffect(() => {
		getDataProvinsi('');

		// get parent by reff code
		if (code) {
			getDataByReffCode(code);
		}
	}, [code]);

	return (
		<AuthLayout
			showNavBar={true}
			title="Register"
		>
			<div className="pt-16 pb-4">
				<FormGroup label={'Reff Code'}>
					<div className="flex items-center gap-4">
						<InputTextblock
							value={salesReffCode}
							readOnly={code != undefined && true}
							onChange={(e) => {
								setSalesReffCode(e.target.value);
							}}
							placeholder="Input Code Reff"
							className="w-full read-only:bg-gray-200"
						/>
						<button
							onClick={() => getDataMitra(undefined)}
							disabled={!salesReffCode}
							className="bg-blue-600 text-white rounded p-2.5 disabled:bg-gray-400 disabled:hover:cursor-not-allowed"
						>
							<FiRefreshCw />
						</button>
					</div>
					{selectedParent && (
						<p className="my-3 text-[12px]">
							<span className="font-bold mr-2">Leader:</span>
							{selectedParent?.fullName} ({selectedParent?.email})
						</p>
					)}
				</FormGroup>
				<FormGroup label={'KTP'}>
					<InputTextblock
						value={identityNumber1}
						onChange={(e) => {
							setIdentityNumber1(e.target.value);
						}}
						placeholder="No Induk Kependudukan"
					/>
				</FormGroup>
				<FormGroup label={'No KK'}>
					<InputTextblock
						value={identityNumber2}
						onChange={(e) => {
							setIdentityNumber2(e.target.value);
						}}
						placeholder="No Kartu Keluarga"
					/>
				</FormGroup>
				<FormGroup label={'Nama Lengkap'}>
					<InputTextblock
						value={fullName}
						onChange={(e) => {
							setFullName(e.target.value);
						}}
						placeholder="Nama Lengkap"
					/>
				</FormGroup>
				<FormGroup label={'Jenis Kelamin'}>
					<div className="flex gap-2">
						<RadioButton
							value="male"
							checked={gender === 'male'}
							onChange={(e) => handleGenderChange(e.target.value)}
							label="Laki-laki"
						/>
						<RadioButton
							value="female"
							checked={gender === 'female'}
							onChange={(e) => handleGenderChange(e.target.value)}
							label="Perempuan"
						/>
					</div>
				</FormGroup>
				<FormGroup label={'Tempat Lahir'}>
					<InputTextblock
						value={placeOfBirth}
						onChange={(e) => setPlaceOfBirth(e.target.value)}
						placeholder="Tempat Lahir"
					/>
				</FormGroup>
				<FormGroup label={'Tanggal Lahir'}>
					<InputDate
						startDate={birthDate}
						onChange={(date: Date) => {
							setBirthDate(date);
						}}
					/>
				</FormGroup>
				<h2 className="text-[12px] font-bold mt-8 pb-2 border-b">Alamat</h2>
				<FormGroup label={'Provinsi'}>
					<SelectDropDown
						options={provinsiList}
						value={selectProvinsi}
						onChange={(e: Toption) => {
							setSelectProvinsi(e);
							if (e !== selectProvinsi) {
								setSelectCity(initialOption);
								setSelectDistrict(initialOption);
								getDataCity('', e.value);
								getDataDistrict('', '0');
							}
							getDataCity('', e.value);
						}}
						onInputChange={(e) => {
							getDataProvinsi(e);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Kota'}>
					<SelectDropDown
						options={cityList}
						value={selectCity}
						onChange={(e) => {
							setSelectCity(e);
							if (e !== selectCity) {
								setSelectDistrict(initialOption);
								getDataDistrict('', e.value);
							}
						}}
						onInputChange={(e) => {
							getDataCity(e, selectProvinsi.value);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Kecamatan'}>
					<SelectDropDown
						options={districtList}
						value={selectDistrict}
						onChange={(e) => {
							setSelectDistrict(e);
						}}
						onInputChange={(e) => {
							getDataDistrict(e, selectCity.value);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Alamat'}>
					<InputTextArea
						value={address1}
						onChange={(e) => setAddress1(e.target.value)}
						placeholder="Alamat"
					/>
				</FormGroup>
				<h2 className="text-[12px] font-bold mt-8 pb-2 border-b">Account</h2>
				<FormGroup label="Phone">
					<InputPhoneNumber
						onChage={(e) => setPhone(e)}
						value={phone}
					/>
				</FormGroup>
				<FormGroup label={'Email'}>
					<InputTextblock
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
						}}
						placeholder="Email"
					/>
				</FormGroup>
				<FormGroup label={'Password'}>
					<InputTextIcon
						value={password}
						onChange={(e) => {
							setPassword(e.target.value);
						}}
						placeholder="Password"
						type={!showPassword ? 'password' : 'text'}
						icon={!showPassword ? 'FaEyeSlash' : 'FaEye'}
						onClick={() => {
							setShowPassword(!showPassword);
						}}
					/>
				</FormGroup>
				<div className="my-8">
					<ButtonBlockPrimary
						onClick={() => {
							onSubmit();
						}}
						label="Next"
					/>
				</div>
			</div>
		</AuthLayout>
	);
};

export default Register;
